import React from 'react';
import './App.css';
import { Routes, Route } from "react-router-dom"

import LluviaComponent from "./components/LluviaComponent";
import TableComponent from "./components/TableComponent";

function App() {
    return (
        <div>
            <Routes>
                <Route path="/"  element={<LluviaComponent />} />
                <Route path="/tablero" element={<TableComponent />} />
            </Routes>
        </div>

    );
}

export default App;
